// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.50001 9L20.5 9L20.5 5H10.362L7.36205 2.5H0V21H20L24 11L4 11L0 21L2.50001 9Z"}}]};

const FolderOpen1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-open-1-filled',
    ref,
    icon: element,
  },
));

FolderOpen1FilledIcon.displayName = 'FolderOpen1FilledIcon';

export default FolderOpen1FilledIcon;
